import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = { class: "responsive-row header" }


export default /*@__PURE__*/_defineComponent({
  __name: 'DisbursementSummaryItem',
  props: {
    header: {},
    details: {}
  },
  setup(__props: any) {

const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("li", null, [
    _createElementVNode("div", _hoisted_1, _toDisplayString(__props.header), 1),
    _createElementVNode("div", null, _toDisplayString(__props.details), 1)
  ]))
}
}

})